import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full">
      {/* Main footer */}
      <div className="bg-primary-700">
        <div className="max-w-6xl mx-auto px-4 md:px-8 pt-14 pb-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            {/* Brand */}
            <div>
              <h3 className="font-heading text-xl font-bold text-white mb-2">
                {t('siteName')}
              </h3>
              <p className="text-primary-200 text-sm leading-relaxed mb-3">
                {t('companyIntro')}
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="inline-flex items-center gap-1 bg-primary-600 text-primary-100 px-2.5 py-1 rounded-full text-xs font-medium">
                  <i className="ri-shield-check-line text-xs" />
                  高级营养师
                </span>
                <span className="inline-flex items-center gap-1 bg-primary-600 text-primary-100 px-2.5 py-1 rounded-full text-xs font-medium">
                  <i className="ri-heart-pulse-line text-xs" />
                  高级健康管理师
                </span>
              </div>
            </div>

            {/* Quick links */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-white uppercase tracking-wider mb-4">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-primary-200 text-sm hover:text-white transition-colors">
                    {t('navHome')}
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-primary-200 text-sm hover:text-white transition-colors">
                    {t('navAbout')}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact info */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-white uppercase tracking-wider mb-4">
                {t('contactUs')}
              </h4>
              <div className="space-y-2.5 text-sm text-primary-200">
                <p className="flex items-start gap-2">
                  <i className="ri-building-line text-primary-300 mt-0.5 flex-shrink-0" />
                  <span>{t('footerCompany')}</span>
                </p>
                <p className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-primary-300 mt-0.5 flex-shrink-0" />
                  <span>{t('footerAddress')}</span>
                </p>
                <p className="flex items-start gap-2">
                  <i className="ri-mail-line text-primary-300 mt-0.5 flex-shrink-0" />
                  <span className="text-xs leading-relaxed">
                    {t('contactEmail')}：<br />
                    <a href="mailto:alexus@quickherbs.vip" className="hover:text-white transition-colors">alexus@quickherbs.vip</a>
                    <br />
                    <a href="mailto:jerry@quickherbs.vip" className="hover:text-white transition-colors">jerry@quickherbs.vip</a>
                  </span>
                </p>
                <p className="flex items-start gap-2">
                  <i className="ri-wechat-line text-primary-300 mt-0.5 flex-shrink-0" />
                  <span className="text-xs">
                    {t('wechatServiceAccount')}：<span className="font-semibold text-white">quickherbs</span>
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mt-10 pt-6 border-t border-primary-600">
            <div className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-alert-line text-white text-xs" />
              </div>
              <p className="text-primary-300 text-xs leading-relaxed">
                {t('noMedicalAdvice')}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="bg-primary-800 py-3.5 px-4">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-center">
          <p className="text-xs text-primary-400">
            © 2026 {t('footerCompany')} {t('allRightsReserved')}
          </p>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-xs text-primary-400 hover:text-primary-200 transition-colors"
          >
            {t('icpRecord')}
          </a>
        </div>
      </div>
    </footer>
  );
}